import { usePageMeta } from "@/lib/seo";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function ContentDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  usePageMeta(c ? `${c.title} | Just be you` : "The Library | Just be you", c?.excerpt);

  useEffect(() => {
    api.get(`/content/${slug}`).then((r) => setC(r.data)).catch(() => {});
  }, [slug]);

  if (!c) {
    return <div className="max-w-3xl mx-auto px-6 py-24 text-ink/50 font-serif italic">listening…</div>;
  }

  return (
    <article className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="content-detail-page">
      <button onClick={() => navigate("/library")} className="text-ink/60 hover:text-lapis text-xs tracking-[0.2em] uppercase mb-12 inline-flex items-center gap-2 font-semibold" data-testid="back-to-library-btn">
        <ArrowLeft size={14} /> Back to library
      </button>

      <div className="overline mb-5">{c.type} · {c.category}</div>
      <h1 className="font-serif text-4xl md:text-5xl text-lapis font-light leading-tight" data-testid="content-title">{c.title}</h1>
      {c.duration && <div className="mt-4 text-xs text-ink/50 uppercase tracking-widest">{c.duration}</div>}

      <div className="my-10 aspect-video overflow-hidden rounded-[2rem]">
        <img src={c.image} alt={c.title} className="w-full h-full object-cover" />
      </div>

      {c.type === "audio" && c.media_url && (
        <audio controls className="w-full mt-4" data-testid="content-audio-player">
          <source src={c.media_url} />
        </audio>
      )}
      {c.type === "video" && c.media_url && (
        <video controls className="w-full mt-4 rounded-2xl" data-testid="content-video-player">
          <source src={c.media_url} />
        </video>
      )}

      {c.body && (
        <div className="mt-12">
          {c.body.split("\n\n").map((block, i) => {
            const b = block.trim();
            if (b.startsWith("**") && b.endsWith("**")) {
              return (
                <h2 key={i} className="font-serif text-2xl text-lapis font-medium mt-12 mb-4">
                  {b.slice(2, -2)}
                </h2>
              );
            }
            if (b.startsWith("*") && b.endsWith("*") && !b.startsWith("**")) {
              return (
                <p key={i} className="font-serif italic text-ink/60 text-lg leading-loose mt-8">
                  {b.slice(1, -1)}
                </p>
              );
            }
            return (
              <p key={i} className="text-lg text-ink/80 leading-loose mt-6 whitespace-pre-line">
                {b}
              </p>
            );
          })}
        </div>
      )}

      <div className="divider-soft my-16" />
      <div className="text-center font-serif italic text-ink/60">— held with care, returned in love.</div>
    </article>
  );
}
